module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.tournament && _vm.tournament.location) ? _c('div', [(_vm.isMine(_vm.tournament)) ? _c('md-toolbar', [_c('md-button', {
    staticClass: "md-icon-button",
    attrs: {
      "disabled": _vm.disableSave
    },
    on: {
      "click": function($event) {
        _vm.save()
      }
    }
  }, [_c('md-icon', [_vm._v("save")]), _vm._v(" "), _c('md-tooltip', [_vm._v("Save venue usage")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-list', _vm._l((_vm.tournament.location.venues), function(venue) {
    return _c('md-list-item', {
      key: venue.id
    }, [_c('md-switch', {
      attrs: {
        "value": venue.id
      },
      model: {
        value: (_vm.inUse),
        callback: function($$v) {
          _vm.inUse = $$v
        },
        expression: "inUse"
      }
    }, [_vm._v(_vm._s(venue.name) + _vm._s(venue.reservedBy && (" - " + (venue.reservedBy))))])], 1)
  }))], 1) : _c('div', [_c('p', [_vm._v("Location is not set for this tournament")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-043ba325","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tournamentComponents/tournamentVenues.vue
// module id = 434
// module chunks = 1